import Vue from "vue";
import Vuetify from "vuetify/lib";
import calendar from "../assets/calendar.svg";
import "@mdi/font/css/materialdesignicons.css";

Vue.use(Vuetify);
Vue.use(calendar);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#003160",
        secondary: "#52BBE5",
        error: "#F2615F",
        accent: "#003160",
      },
    },
  },
  icons: {
    iconfont: "mdi",
  },
});
